import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'Dra. María Fernández',
    location: 'Buenos Aires',
    age: 45,
    text: 'Trabajo con adultos mayores hace 15 años y este kit me dio la estructura que me faltaba. Ahora las primeras consultas son mucho más ordenadas y sé exactamente qué evaluar.'
  }, {
    name: 'Lic. Roberto Gómez',
    location: 'Córdoba',
    age: 52,
    text: 'El protocolo de duelo y pérdidas es excelente. Me ayudó a acompañar procesos difíciles con más seguridad profesional y criterio clínico.'
  }, {
    name: 'Lic. Claudia Morales',
    location: 'Rosario',
    age: 38,
    text: 'Recién empiezo a trabajar en un geriátrico y este sistema me salvó. Las guías para contexto institucional y familia son clarísimas y aplicables desde el primer día.'
  }, {
    name: 'Dr. Javier Peralta',
    location: 'Mendoza',
    age: 58,
    text: 'Después de años improvisando, encontré un sistema que realmente funciona. La plantilla de evaluación inicial es oro puro, no pierdo información importante.'
  }, {
    name: 'Lic. Silvina Castro',
    location: 'La Plata',
    age: 41,
    text: 'Me costaba diferenciar deterioro cognitivo leve de otros cuadros. El protocolo específico me dio herramientas concretas para trabajar sin perder profundidad terapéutica.'
  }];
  return <section className="w-full py-16 md:py-24 bg-white" data-id="element-135">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-136">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-137">
          <h2 className="text-3xl md:text-4xl font-bold text-[#14505c] mb-12 text-center" data-id="element-138">
            Lo que dicen los profesionales
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-139">
            {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.1
          }} className="bg-[#faf9f7] p-6 rounded-lg shadow-md" data-id="element-140">
                <div className="flex gap-1 mb-4" data-id="element-141">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-[#d97706] text-[#d97706]" data-id="element-142" />)}
                </div>
                <p className="text-gray-700 mb-4 italic" data-id="element-143">
                  "{testimonial.text}"
                </p>
                <div className="border-t border-gray-300 pt-4" data-id="element-144">
                  <p className="font-bold text-[#14505c]" data-id="element-145">{testimonial.name}</p>
                  <p className="text-sm text-gray-600" data-id="element-146">
                    {testimonial.location} · {testimonial.age} años
                  </p>
                </div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}